import { useEffect, useState } from "react";
import clsx from "clsx";


function Toast({ message, type = "info", duration = 3000, onClose }) {
  const [isVisible, setIsVisible] = useState(!!message);

  useEffect(() => {
    setIsVisible(true);
    if (duration && duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  if (!isVisible || !message) return null;

  const typeStyles = {
    success: "bg-green-450 text-white",
    error: "bg-red-600 text-white",
    warning: "bg-yellow-500 text-white",
    info: "bg-blue-350 text-white",
  };

  const typeIcons = {
    success: (
      <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z" fill="currentColor"/>
      </svg>
    ),
    error: (
      <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="currentColor"/>
      </svg>
    ),
    warning: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="currentColor"/>
      </svg>
    ),
    info: (
      <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V9H11V15ZM11 7H9V5H11V7Z" fill="currentColor"/>
      </svg>
    ),
  };

  const ariaRole = type === "error" ? "alert" : "status";

  // Mock `.toast`: an inverted pill at the bottom centre, above the DirtyBar, no icon and no close button.
  if (type === "neutral") {
    return (
      <div
        role="status"
        className="fixed bottom-7 left-1/2 z-[60] max-w-[min(90vw,420px)] -translate-x-1/2 rounded-xl bg-text px-[18px] py-2.5 text-center text-[13px] font-semibold text-bg shadow-card animate-fade-in motion-reduce:animate-none">
        {message}
      </div>
    );
  }

  return (
    <div
      role={ariaRole}
      className={clsx(
        "fixed top-5 right-5 flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg max-w-xs z-50 animate-in fade-in slide-in-from-bottom-4 duration-300",
        typeStyles[type]
      )}
    >
      <div className="flex-shrink-0">
        {typeIcons[type]}
      </div>
      <div className="flex-1 text-sm font-medium whitespace-normal w-full max-w-xs">
        {message}
      </div>
      <button
        onClick={() => {
          setIsVisible(false);
          if (onClose) onClose();
        }}
        className="flex-shrink-0 ml-2 hover:opacity-75 transition"
      >
				<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block">
					<path d="M12.421 0.43918C12.1398 0.157973 11.7583 0 11.3605 0C10.9628 0 10.5813 0.157973 10.3001 0.43918L6.42106 4.31818L2.54206 0.43918C2.25916 0.165943 1.88026 0.0147513 1.48696 0.0181689C1.09367 0.0215866 0.717451 0.17934 0.439339 0.457452C0.161227 0.735564 0.00347433 1.11178 5.67039e-05 1.50508C-0.00336092 1.89837 0.14783 2.27728 0.421067 2.56018L4.30006 6.43918L0.421067 10.3182C0.14783 10.6011 -0.00336092 10.98 5.67039e-05 11.3733C0.00347433 11.7666 0.161227 12.1428 0.439339 12.4209C0.717451 12.699 1.09367 12.8568 1.48696 12.8602C1.88026 12.8636 2.25916 12.7124 2.54206 12.4392L6.42106 8.56018L10.3001 12.4392C10.583 12.7124 10.9619 12.8636 11.3552 12.8602C11.7484 12.8568 12.1247 12.699 12.4028 12.4209C12.6809 12.1428 12.8386 11.7666 12.8421 11.3733C12.8455 10.98 12.6943 10.6011 12.421 10.3182L8.54205 6.43918L12.421 2.56018C12.7023 2.27889 12.8602 1.89743 12.8602 1.49968C12.8602 1.10193 12.7023 0.720471 12.421 0.43918Z" fill="white"/>
				</svg>
    </button>
		</div>
  );
}

export default Toast;
